var _ellipse, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSession1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.4355,
    cy: 13.1469,
    rx: 12.5,
    ry: 12.5824,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4355 13.1469C25.4355 19.8229 20.0599 25.2293 13.4355 25.2293C6.81122 25.2293 1.43555 19.8229 1.43555 13.1469C1.43555 6.47083 6.81122 1.06445 13.4355 1.06445C20.0599 1.06445 25.4355 6.47083 25.4355 13.1469Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3105 22.2046C12.3105 22.2046 11.1855 22.2046 11.1855 20.6947C11.1855 19.1848 12.3105 14.6552 16.8105 14.6552C21.3105 14.6552 22.4355 19.1848 22.4355 20.6947C22.4355 22.2046 21.3105 22.2046 21.3105 22.2046H12.3105ZM16.8105 13.1453C17.7057 13.1453 18.5641 12.668 19.197 11.8186C19.83 10.9691 20.1855 9.81695 20.1855 8.61561C20.1855 7.41427 19.83 6.26213 19.197 5.41265C18.5641 4.56317 17.7057 4.08594 16.8105 4.08594C15.9154 4.08594 15.057 4.56317 14.4241 5.41265C13.7911 6.26213 13.4355 7.41427 13.4355 8.61561C13.4355 9.81695 13.7911 10.9691 14.4241 11.8186C15.057 12.668 15.9154 13.1453 16.8105 13.1453Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3035 22.2044C10.1368 21.733 10.0536 21.2162 10.0605 20.6945C10.0605 18.6486 10.8255 16.5423 12.2385 15.0777C11.5333 14.7861 10.7985 14.6434 10.0605 14.6549C5.56055 14.6549 4.43555 19.1846 4.43555 20.6945C4.43555 22.2044 5.56055 22.2044 5.56055 22.2044H10.3035Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49805 13.1454C10.244 13.1454 10.9593 12.7477 11.4868 12.0398C12.0142 11.3319 12.3105 10.3718 12.3105 9.37067C12.3105 8.36955 12.0142 7.40944 11.4868 6.70154C10.9593 5.99364 10.244 5.59595 9.49805 5.59595C8.75213 5.59595 8.03676 5.99364 7.50931 6.70154C6.98186 7.40944 6.68555 8.36955 6.68555 9.37067C6.68555 10.3718 6.98186 11.3319 7.50931 12.0398C8.03676 12.7477 8.75213 13.1454 9.49805 13.1454Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSession1);
export default __webpack_public_path__ + "static/media/session1.a022dad67449495dd2cb6608e01fcde8.svg";
export { ForwardRef as ReactComponent };